import React from "react";
import "../css/TextFile.css";

function About() {
  return (
    <div className="textfile-container">
      <h1>hellooo! i'm mena</h1>
      <br />
      <p>
        <b>Software Engineer</b> @ JPMorgan Chase &amp; Co.
      </p>
      <p>
        <b>CS '20</b> @ Cornell University
      </p>
    </div>
  );
}

export default About;
